export default "__VITE_ASSET__fe0f575d__"